import { useMutation } from '@tanstack/react-query';
import { auth } from '../config/firebase';

interface CreateCheckoutSessionParams {
  priceId: string;
  successUrl?: string;
  cancelUrl?: string;
}

export const useCheckoutSession = () => {
  return useMutation({
    mutationFn: async ({ priceId, successUrl, cancelUrl }: CreateCheckoutSessionParams) => {
      const token = await auth.currentUser?.getIdToken();
      if (!token) {
        throw new Error('No authentication token available');
      }

      const response = await fetch('https://api.socialness.ai/stripe/create-checkout-session', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              price: priceId,
              quantity: 1
            }
          ],
          mode: 'subscription',
          successUrl: successUrl || `${window.location.origin}/payment/success`,
          cancelUrl: cancelUrl || `${window.location.origin}/payment/cancel`
        })
      });

      if (!response.ok) {
        throw new Error('Failed to create checkout session');
      }

      const data = await response.json();
      return data;
    },
    onSuccess: (data) => {
      // Redirect to Stripe Checkout
      window.location.href = data.url;
    }
  });
};